import { iApp_state } from "../../common/interfaces/interfaces"
import { appActionTypes, app_actions_type } from "./appTypes"

const initial_state: iApp_state = {
    clientAddr: '',
    vault: null,
    provider: null,
    periods: null,
    token: '',
    vaults: [],
    closedPeriod: false,
    pool: null,
    params: null,
    stVault: null,
    ltVault: null,
    clientInfo: null,
    priceGainInfo: null,
    accessToken: null,
    session: null,
    chrClientAddr: null,
    gtxClient: null,
    tokens: [],
    balances: null,
    transactionStatus: null,
    isIniting: false,
    fToken: ''
}

export const appReducer = (state = initial_state, action: app_actions_type): iApp_state => {
    switch(action.type){
        case appActionTypes.SET_CLIENT_ADDR:
            return {...state, clientAddr: action.payload}

        case appActionTypes.SET_PRICE_GAIN_INFO:
            return {...state, priceGainInfo: action.payload}

        case appActionTypes.SET_VAULT:
            return {...state, vault: action.payload}

        case appActionTypes.SET_WEB3_PROVIDER:
            return {...state, provider: action.payload}

            case appActionTypes.SET_PERIODS:
            return {...state, periods: action.payload}

        case appActionTypes.SET_TOKEN:
            return {...state, token: action.payload}

        case appActionTypes.SET_VAULTS:
            return {...state, vaults: action.payload}
        
        case appActionTypes.SET_PARAMS:
            return {...state, params: action.payload}

        case appActionTypes.SET_CLOSED_PERIOD:
            return {...state, closedPeriod: action.payload}

        case appActionTypes.SET_POOL:
            return {...state, pool: action.payload}

        case appActionTypes.SET_CLIENT_INFO:
            return {...state, clientInfo: action.payload}

        case appActionTypes.SET_FT_TOKEN:
            return {...state, fToken: action.payload}

        case appActionTypes.SET_LT_VAULT: 
            return {...state, ltVault: action.payload}

        case appActionTypes.SET_ST_VAULT: 
            return {...state, stVault: action.payload}

        case appActionTypes.SET_TRANSACTION_STATUS:
            return {...state, transactionStatus: action.payload}

        case appActionTypes.SET_ACCESS_TOKEN:
            return {...state, accessToken: action.payload}

        case appActionTypes.SET_SESSION:
			return {...state, session: action.payload};

        case appActionTypes.SET_CHR_CLIENT_ADDR:
            return {...state, chrClientAddr: action.payload};

        case appActionTypes.SET_BALANCES:
            return {...state, balances: action.payload};

        case appActionTypes.SET_IS_INITING:
            return {...state, isIniting: action.payload};

        case appActionTypes.ADD_TOKEN:
            const tokensSlice = state.tokens.slice();
            tokensSlice.push(action.payload);
            return {...state, tokens: tokensSlice};     

        case appActionTypes.CLEAR_APP_STATE:
            return {...initial_state}

        default: return state;
    }
}